import { useMemo, useState } from 'react';
import { AccommodationConsoleListingPropertyFragment, AccommodationsConsolePropertiesQuery, useAccommodationsConsolePropertiesQuery } from '@graphql/generated';
import { useBatchedListingPrices } from './useBatchedListingPrices';
import { AccommodationsConsoleState } from '@apps/accommodations/AccommodationsConsole.types';

interface UseAccommodationsConsoleListingsArgs {
  state: AccommodationsConsoleState;
}

export const useAccommodationsConsoleListings = (args: UseAccommodationsConsoleListingsArgs) => {
  const { state } = args;

  const [cachedListings, setCachedListings] = useState<NonNullable<AccommodationsConsolePropertiesQuery['searchAccommodationProperties']>['properties']>([]);

  const { data, loading: isFetchingListings } = useAccommodationsConsolePropertiesQuery({
    variables: {
      payload: {
        circularRegionSearch: state.circularRegionSearch
      }
    },
    batchMode: 'off',
    onCompleted: data => {
      if (data?.searchAccommodationProperties?.properties) {
        setCachedListings(data.searchAccommodationProperties.properties);
      }
    }
  });

  const listingsWithoutPricing: Array<AccommodationConsoleListingPropertyFragment> = useMemo(() => {
    return data?.searchAccommodationProperties?.properties || [];
  }, [data]);

  const { listings, isFetchingListingPrices, error } = useBatchedListingPrices({
    listingsWithoutPricing,
    state
  });

  return {
    /**
     * Can be used to retain maps points while loading new data
     */
    cachedListings,
    listings,
    isFetchingListings,
    isFetchingListingPrices,
    pricingError: error
  };
};
